module.exports = __webpack_public_path__ + "static/img/4.1cbe317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/4.jpg
// module id = UjIg
// module chunks = 12